import { C } from "../tokens";

interface Props {
  data: number[];
  color?: string;
  width?: number;
  height?: number;
  filled?: boolean;
  strokeWidth?: number;
}

/** Zero-dependency SVG sparkline. Auto-scales to min/max of `data`. */
export function Sparkline({
  data, color = C.blue, width = 100, height = 30, filled = true, strokeWidth = 1.5,
}: Props) {
  if (!data.length) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1 || 1);
  const pts = data.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 4) - 2;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  const areaPath = `M0,${height} L${pts.replace(/ /g, " L")} L${width},${height} Z`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: "block", overflow: "visible" }}>
      {filled && (
        <defs>
          <linearGradient id={`sg-${color.replace("#", "")}`} x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.4} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
      )}
      {filled && <path d={areaPath} fill={`url(#sg-${color.replace("#", "")})`} />}
      <polyline
        points={pts}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
